import { render, staticRenderFns } from "./giftcard-list2.vue?vue&type=template&id=6e7c1d62&scoped=true&"
import script from "./giftcard-list2.vue?vue&type=script&lang=js&"
export * from "./giftcard-list2.vue?vue&type=script&lang=js&"
import style0 from "./giftcard-list2.vue?vue&type=style&index=0&id=6e7c1d62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c1d62",
  null
  
)

export default component.exports